<template>
    <div :title="title" :class="{ disabled: !enabled }" class="cic-ui-button" @click="handleClick">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'CicButton',
        props: {
            enabled: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: null,
            },
        },
        emits: ['click'],
        methods: {
            // Handle button click
            handleClick() {
                if (this.enabled) {
                    this.$emit('click');
                }
            },
        },
    };
</script>
